<script setup lang="ts">
import { useI18n } from "vue-i18n";
import Button from "@/design/primitives/Button.vue";
import EmptyState from "@/design/primitives/EmptyState.vue";

/**
 * O CÓDIGO DA TELA NÃO CHEGOU — dito, em vez de acontecer em silêncio.
 *
 * ── O QUE ISTO SUBSTITUI ──────────────────────────────────────────────────
 *
 * Nada, e é esse o ponto. Enquanto o router esperava pelo `import()` para
 * comitar, um chunk que falhava REJEITAVA a navegação: o endereço não mudava, a
 * tela anterior continuava desenhada, e a pessoa ficava a clicar num item de
 * menu que não fazia nada. O modo de falha mais caro que existe é o que se
 * parece com um produto lento.
 *
 * O caso real não é hipotético: um separador aberto antes de um deploy pede um
 * ficheiro com o hash antigo. O `deploy.sh` deixa os assets velhos em disco de
 * propósito por causa disso, o que resolve a maioria — mas não a rede a cair no
 * meio, nem um deploy antigo o suficiente para o ficheiro já ter saído.
 *
 * ── POR QUE O BOTÃO RECARREGA A PÁGINA ────────────────────────────────────
 *
 * Porque tentar o mesmo `import()` outra vez é insistir no mesmo URL, e no caso
 * do deploy é precisamente o URL que deixou de existir. Um `location.reload()`
 * vai buscar o `index.html` novo, que nomeia os assets novos — é o único gesto
 * que cura a causa e não só o sintoma. A tentativa barata (uma repetição
 * imediata, para o soluço de rede) já foi feita antes de se chegar aqui, em
 * `lazy-page.ts`.
 */
const { t } = useI18n();

function reload(): void {
	window.location.reload();
}
</script>

<template>
	<main class="min-w-0 flex-1 overflow-y-auto px-4 py-5 sm:px-6">
		<EmptyState :title="t('chunk.title')" :hint="t('chunk.hint')" icon="refresh">
			<Button size="sm" @click="reload">{{ t("chunk.retry") }}</Button>
		</EmptyState>
	</main>
</template>
